import '../../../FE/src/assets/javascripts/libs/slick.js';

export default class LatestNews {
  constructor(el) {
    this.$el = $(el);
    this.$slider = this.$el.find('.gg-latest-news__slider');
    // eslint-disable-next-line radix
    this.autoplaySpeed = parseInt(this.$el.data('autoplay-speed')) || 3000;
    this.isPlaying = true;
    this.$pauseBtn = this.$el.find('.gg-latest-news__pause-btn');
  }

  init() {
    this.initSlider();
    this.bindEvents();
  }

  initSlider() {
    if (this.$slider.length === 0) {
      return;
    }

    // Initialize Slick slider with standard arrow controls
    this.$slider.slick({
      rows: 0,
      slide: '.gg-news__card',
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: this.autoplaySpeed,
      arrows: true,
      dots: false,
      swipe: true,
      draggable: true,
      speed: 600,
      appendArrows: this.$el.find('.slick-controls'),
      prevArrow: `
        <button type="button" class="slick-prev gg-slick-arrow gg-slick-arrow-green">
          <span class="icomoon icon-arrow-left"></span>
        </button>
      `,
      nextArrow: `
        <button type="button" class="slick-next gg-slick-arrow gg-slick-arrow-green">
          <span class="icomoon icon-arrow-right"></span>
        </button>
      `,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
    this.setActiveSlide();
    this.$slider.on('beforeChange', () => {
      this.setActiveSlide();
    });
  }

  bindEvents() {
    // Pause/Play button
    if (this.$pauseBtn.length) {
      this.$pauseBtn.on('click', () => {
        this.isPlaying = !this.isPlaying;

        if (this.isPlaying) {
          this.$slider.slick('slickPlay');
          this.$pauseBtn.html(`
            <span class="icomoon icon-pause"></span>
          `);
          this.$pauseBtn.attr('aria-label', 'Pause slider');
        } else {
          this.$slider.slick('slickPause');
          this.$pauseBtn.html(`
            <span class="icomoon icon-play"></span>
          `);
          this.$pauseBtn.attr('aria-label', 'Play slider');
        }
      });
    }

    // Pause on hover
    this.$slider.on('mouseenter', () => {
      this.$slider.slick('slickPause');
    });

    this.$slider.on('mouseleave', () => {
      if (this.isPlaying) {
        this.$slider.slick('slickPlay');
      }
    });
  }

  setActiveSlide() {
    this.$slider.find('.active').removeClass('active');
    setTimeout(() => {
      const $slickActive = this.$slider.find('.slick-active');
      $slickActive.each((_index, element) => {
        const dataIndex = $(element).data('index');
        this.$slider.find(`[data-index="${dataIndex}"]`).addClass('active');
      });
    }, 0);
  }
}

// Initialize on page load
if (typeof window.acf === 'undefined') {
  $(document).ready(() => {
    $('.gg-latest-news').each((_index, el) => {
      new LatestNews(el).init();
    });
  });
} else {
  // eslint-disable-next-line
  acf.addAction('render_block_preview/type=acf/gravity-latest-news', ($el) => {
    $el.find('.gg-latest-news').each((_index, el) => {
      new LatestNews(el).init();
    });
  });
}
